import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { TextField, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        paddingBottom: "20px"
    }
}));

const UDFNumber = (props) => {
    const { UDF } = props;
    const classes = useStyles();

    const onChangeHandler = (event) => {
        props.changecontrolvalue(event, props.bookingID, UDF.UDFCategoryName, UDF.UDFID);
    }

    const GetUserMemberValue = () => {
        if (props.isMembership) {
            let userV = "";

            if (UDF.Users.filter(x => x.userID == props.usernumber).length > 0) {
                let user = UDF.Users.find(x => x.userID == props.usernumber);

                if (user && user.hasOwnProperty('userUDFValue')) {
                    userV = user.userUDFValue;
                }

                return userV;
            }
        }
        else {
            return UDF.Value;
        }
    }

    return (
        <div className={classes.root}>
            <Typography variant="subtitle1">{UDF.UdfDescription}</Typography>
            <TextField
                id={UDF.UDFID.toString()}
                name={UDF.UDFID.toString()}
                label={UDF.Name}
                type="Number"
                required={UDF.IsRequired}
                onChange={onChangeHandler}
                value={GetUserMemberValue()}
                inputProps={{ maxLength: UDF.UDFLength }}
                InputLabelProps={{
                    style: { padding: "0 0 0 15px" },
                }}
                {...props}
            />
        </div>
    );
};

UDFNumber.propTypes = {
    UDF: PropTypes.object.isRequired
};

export default UDFNumber;
